import React from "react";
import { apiPanIndiaCommercial } from '../../services/apis/retail/apiPanIndiaCommercial'

class PanIndiaCommercial extends React.Component {
    state = {
        noOfDevelopers: 0,
        noOfGroupCompanies: 0
    }

    componentDidMount() {
        apiPanIndiaCommercial.get().then((res) => {
            this.setState({ noOfDevelopers: res.data.no_of_developers });
        });
    }
    render() {
        return (
            <div className="col-lg-4 mb-4">
                <div className="widget">
                    <div className="row">
                        <div className="col-lg-4 flexCenter">
                            <img
                                alt="Pan India Commercial Icon"
                                src="/edge/images/pan_india_commercial.png"
                                className="imgWidth100"
                            />
                        </div>
                        <div className="col-lg-8 text-start colorLightBlue">
                            <h1>
                                {this.state.noOfDevelopers} <span className="smallText">Developers</span>
                            </h1>
                            {/* <p>({this.state.noOfGroupCompanies} Group Companies)</p> */}
                        </div>
                    </div>
                    <p className="widgetName">Pan India Commercial</p>
                </div>
            </div>
        );
    }
}

export default PanIndiaCommercial;
